<app-banner [loading]="false" [info]="true" heading='Revalidation' subHeading="View and manage exceptional circumstances and remediation" >

</app-banner>
<div class="content spread">

  <div class="row fadein">

    <app-form-section class="col-sm-4 left-col  clickable" [link]="'/revalidation/extenuating-circumstances'">
      <span class="section-header">Exceptional circumstances</span>
      <div class="section-body">
        View and manage exceptional circumstance submissions
      </div>
    </app-form-section>
  <app-form-section class="col-sm-4 mid-col clickable" [link]="'/revalidation/remediation'">
      <span class="section-header">Remediation</span>
      <div class="section-body">
        View registrants in remediation, NIR and NOR
      </div>
    </app-form-section>

    <app-form-section class="col-sm-4 right-col clickable" [link]="'/revalidation/review'">
      <span class="section-header">Review</span>
      <div class="section-body">
        Review management
      </div>
    </app-form-section>

    <app-form-section class="col-sm-4 left-col clickable" [link]="'/revalidation/submission-enquiry'">
      <span class="section-header">Submission enquiry</span>
      <div class="section-body">
        View revalidation records
      </div>
    </app-form-section>

    <app-form-section class="col-sm-4 left-col clickable" [link]="'/revalidation/granted-revalidations'">
      <span class="section-header">Revalidation extensions</span>
      <div class="section-body">
        View granted revalidation records
      </div>
    </app-form-section>

  </div>
</div>